import type { CmsApiPagePage } from '#/modules/cms/api/types/CmsApiPage';
import { useReloadIfFreeCodeBlockAndClientNavigation } from '#/modules/cms/hooks/useReloadIfFreeCodeBlockAndClientNavigation';
import { useCmsPageRevalidateAfterUserAuthentication } from '#/modules/cms/pages/splat/cmsSplatRouteRevalidation';
import { NotFoundPageLoadable } from '#/pages/NotFound/NotFoundPageLoadable';

import { CmsPagePageBody } from './CmsPagePageBody';
import { CmsPagePageLayout } from './CmsPagePageLayout';

type Props = {
  content: CmsApiPagePage;
};

export function CmsPagePage({ content }: Props) {
  useCmsPageRevalidateAfterUserAuthentication();

  const { showPageNotFound } =
    useReloadIfFreeCodeBlockAndClientNavigation(content);
  if (showPageNotFound) return <NotFoundPageLoadable />;

  return (
    <CmsPagePageLayout content={content}>
      <CmsPagePageBody content={content} />
    </CmsPagePageLayout>
  );
}
